<div
  class="header-notification flex flex-row justify-center"
  [class.header-notification--message]="type === 'message'"
  [class.header-notification--error]="type === 'error'"
  [class.header-notification--notification]="type === 'notification'"
  [class.header-notification--warning]="type === 'warning'"
  @inFromTop>
  <div class="text-14 flex flex-row justify-center items-center flex-auto">
    <div class="mr-3">
      <app-icon icon="exclamation-triangle"></app-icon>
    </div>

    <div>
      <ng-content></ng-content>
    </div>
  </div>

  <button
    app-button
    buttonType="text"
    buttonTheme="light"
    type="button"
    (click)="handleDismissClicked()"
    title="Dismiss"
    [attr.aria-label]="'Dismiss'">
    <app-icon icon="times" size="lg"> </app-icon>
  </button>
</div>
